import { useTranslation } from "locales";
import type { IMenuItem } from "@venuepos/react-common";
import { useAdminSession } from "../session";
import { useMemo } from "react";

// Note: This used to be the preferred method of adding menu items.
// Please use the navigation-routes.tsx file instead and only this for custom stuff without routes
export function useAdminMenuItems(): IMenuItem[] {
    const [t] = useTranslation();
    const [{ locale }, setSession] = useAdminSession(["locale"]);

    const items = useMemo(() => {
        return [
            locale !== "da"
                ? {
                      name: t("menu.language.danish", "🇩🇰 Dansk"),
                      link: () => setSession("locale", "da"),
                      testID: "language:da",
                  }
                : null,
            locale !== "de"
                ? {
                      name: t("menu.language.german", "🇩🇪 Deutsch"),
                      link: () => setSession("locale", "de"),
                      testId: "language:de",
                  }
                : null,
            locale !== "en"
                ? {
                      name: t("menu.language.english", "🇬🇧 English"),
                      link: () => setSession("locale", "en"),
                      testID: "language:en",
                  }
                : null,
        ].filter(Boolean);
    }, [locale, setSession, t]);

    return [
        {
            name: t("menu.language.menu", "Language"),
            iconName: "language",
            items,
            testID: "menu:languages",
        },
    ];
}
